import { Box } from '@mui/material'
import { useFrozenProduction } from './EditSettings.data'
import { useEffect, useState } from 'react'
import {
  EditSettingsTabViewProps,
  FrozenProductionRow,
} from './EditSettings.types'
import { Loader } from 'Common/Loader/Loader'
import { FrozenProductionMUITable } from './FrozenProduction.MUITable'

export const FrozenProductionTab = ({
  enabled,
  planId,
}: EditSettingsTabViewProps) => {
  const [frozenProduction, setFrozenProduction] = useState<
    [] | FrozenProductionRow[]
  >([])
  const {
    data: frozenProductionData,
    isLoading: isFrozenProductionDataLoading,
  } = useFrozenProduction(planId, enabled)

  useEffect(() => {
    setFrozenProduction(frozenProductionData)
  }, [frozenProductionData])

  if (isFrozenProductionDataLoading) {
    return <Loader />
  }
  return (
    <Box padding={0} marginTop={2}>
      <Box>
        {frozenProduction && frozenProduction.length > 0 && (
          <FrozenProductionMUITable
            data={frozenProduction ?? []}
            isLoading={isFrozenProductionDataLoading}
          />
        )}
      </Box>
    </Box>
  )
}
